import { useMemo } from 'react'
import type { NextPage, GetStaticPropsContext } from 'next'
import NextLink from 'next/link'
import { useTranslations } from 'next-intl'
import { Text, Link } from '@chakra-ui/react'

import { ContainerAuthentication } from '@/components/containers/ContainerAuthentication'
import { Auth0UniversalLogin } from '@/features/auth/Auth0UniversalLogin'
import { KeycloakUniversalLogin } from '@/features/auth/KeycloakUniversalLogin'
import { RegisterForm } from '@/features/auth/RegisterForm'
import { AUTH0_ENABLED, KEYCLOAK_ENABLED } from '@/constants'
import SeoHead from '@/components/seo-head'

const RegisterPage: NextPage = () => {
  const t = useTranslations()

  const title = useMemo(() => {
    return t.rich('auth.register.title', {
      bold: (children) => (
        <Text as="span" fontWeight="semibold">
          <br />
          {children}
        </Text>
      ),
    })
  }, [t])

  const footer = useMemo(() => {
    return t.rich('auth.register.log-in', {
      link: (children) => (
        <NextLink href="/sign-in">
          <Link>{children}</Link>
        </NextLink>
      ),
    })
  }, [t])

  return (
    <>
      <SeoHead
        title={t('auth.register.seo.title')}
        breadcrumbTitle={t('auth.register.seo.breadcrumb')}
        description={t('auth.register.seo.description')}
      />
      <ContainerAuthentication title={title} footer={footer}>
        {KEYCLOAK_ENABLED && <KeycloakUniversalLogin />}
        {AUTH0_ENABLED && !KEYCLOAK_ENABLED && <Auth0UniversalLogin />}
        {!AUTH0_ENABLED && !KEYCLOAK_ENABLED && <RegisterForm />}
      </ContainerAuthentication>
    </>
  )
}

export async function getStaticProps({ locale }: GetStaticPropsContext) {
  return {
    props: {
      messages: (await import(`../../locales/${locale}.json`)).default,
    },
  }
}

export default RegisterPage
